<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2016 by Alice Kaplan</p>
<p class="crt">All rights reserved. Published 2016.</p>
<p class="crt">Paperback edition 2018</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">27 26 25 24 23 22 21 20 19 18    2 3 4 5 6</p>
<p class="crtf">ISBN-13: 978-0-226-24167-8 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-56536-1 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-24170-8 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226241708.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226241708.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Kaplan, Alice Yaeger, author.</p>
<p class="cip">Title: Looking for The stranger : Albert Camus and the life of a literary classic / Alice Kaplan.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2016. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2016008498 | ISBN 9780226241678 (cloth : alk. paper) | ISBN 9780226241708 (e-book)</p>
<p class="cip">Subjects: LCSH: Camus, Albert, 1913–1960. | Authors, French—Biography. | Philosophers—France—Biography. | Camus, Albert, 1913–1960. L’Étranger. | Camus, Albert, 1913–1960—Appreciation.</p>
<p class="cip">Classification: LCC PQ2605 .A3734 Z6694 2016 | DDC 848/ .91409—dc23</p>
<p class="cip">LC record available at <a class="url" href="http://lccn.loc.gov/2016008498" target="_blank">http://lccn.loc.gov/2016008498</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Kaplan-Stranger-US-pbk-0004.vue?16cc24c2